export default __webpack_public_path__ + "static/media/t_alert.a934cafe.svg";